module.exports = __webpack_public_path__ + "static/SandrineClarac-f8129657cb7d12ee25e8bf966bf54c43.jpg";